export const FingerPrintScanImage: any = {
  v: '5.5.2',
  fr: 25,
  ip: 0,
  op: 116,
  w: 160,
  h: 165,
  nm: 'Validación huellas_01-V2A',
  ddd: 1,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Capa 3 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            r: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                    ],
                    y: [
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                    ],
                    y: [
                      0,
                    ],
                  },
                  t: 8,
                  s: [
                    42,
                  ],
                },
                {
                  t: 17,
                  s: [
                    0,
                  ],
                },
              ],
              ix: 10,
            },
            p: {
              a: 0,
              k: [
                78.753,
                81.23,
                0,
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                65.568,
                63.76,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 8,
                  s: [
                    5,
                    5,
                    100,
                  ],
                },
                {
                  t: 22,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -1.501,
                        ],
                        [
                          1.5,
                          0,
                        ],
                        [
                          0,
                          1.501,
                        ],
                        [
                          -1.501,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          1.501,
                        ],
                        [
                          -1.501,
                          0,
                        ],
                        [
                          0,
                          -1.501,
                        ],
                        [
                          1.5,
                          0,
                        ],
                      ],
                      v: [
                        [
                          2.717,
                          0,
                        ],
                        [
                          0,
                          2.717,
                        ],
                        [
                          -2.717,
                          0,
                        ],
                        [
                          0,
                          -2.717,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      128.168,
                      124.554,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.003,
                          -0.553,
                        ],
                        [
                          0.434,
                          -0.168,
                        ],
                        [
                          0.769,
                          -2.139,
                        ],
                        [
                          0.46,
                          0.008,
                        ],
                        [
                          0.184,
                          0.525,
                        ],
                        [
                          1.227,
                          0.861,
                        ],
                        [
                          0.588,
                          0.27,
                        ],
                        [
                          0.025,
                          0.489,
                        ],
                        [
                          -0.512,
                          0.201,
                        ],
                        [
                          -0.756,
                          2.107,
                        ],
                        [
                          -0.468,
                          0.003,
                        ],
                        [
                          -0.203,
                          -0.564,
                        ],
                        [
                          -2.063,
                          -0.815,
                        ],
                      ],
                      o: [
                        [
                          -0.009,
                          0.445,
                        ],
                        [
                          -2.119,
                          0.819,
                        ],
                        [
                          -0.188,
                          0.522,
                        ],
                        [
                          -0.454,
                          -0.007,
                        ],
                        [
                          -0.494,
                          -1.417,
                        ],
                        [
                          -0.527,
                          -0.37,
                        ],
                        [
                          -0.438,
                          -0.201,
                        ],
                        [
                          -0.023,
                          -0.45,
                        ],
                        [
                          2.085,
                          -0.817,
                        ],
                        [
                          0.19,
                          -0.53,
                        ],
                        [
                          0.488,
                          -0.004,
                        ],
                        [
                          0.754,
                          2.089,
                        ],
                        [
                          0.458,
                          0.181,
                        ],
                      ],
                      v: [
                        [
                          6.003,
                          0.027,
                        ],
                        [
                          5.32,
                          0.948,
                        ],
                        [
                          0.99,
                          5.384,
                        ],
                        [
                          0.001,
                          6.148,
                        ],
                        [
                          -0.973,
                          5.356,
                        ],
                        [
                          -3.527,
                          1.902,
                        ],
                        [
                          -5.234,
                          0.979,
                        ],
                        [
                          -5.98,
                          0.014,
                        ],
                        [
                          -5.23,
                          -0.989,
                        ],
                        [
                          -0.975,
                          -5.375,
                        ],
                        [
                          0.008,
                          -6.152,
                        ],
                        [
                          1.012,
                          -5.349,
                        ],
                        [
                          5.242,
                          -0.997,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      6.253,
                      6.406,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 8,
          op: 758,
          st: 8,
          bm: 0,
        },
        {
          ddd: 1,
          ind: 3,
          ty: 4,
          nm: 'Capa 4 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8,
            },
            ry: {
              a: 0,
              k: 0,
              ix: 9,
            },
            rz: {
              a: 0,
              k: 0,
              ix: 10,
            },
            or: {
              a: 0,
              k: [
                0,
                0,
                0,
              ],
              ix: 7,
            },
            p: {
              a: 0,
              k: [
                78.753,
                81.23,
                0,
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                36.864,
                77.068,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 9,
                  s: [
                    19,
                    19,
                    19,
                  ],
                },
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 17,
                  s: [
                    113,
                    113,
                    113,
                  ],
                },
                {
                  t: 26,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.536,
                          -0.807,
                        ],
                        [
                          -0.464,
                          -0.7,
                        ],
                        [
                          0.537,
                          0.807,
                        ],
                        [
                          0.465,
                          0.7,
                        ],
                      ],
                      o: [
                        [
                          0.465,
                          0.7,
                        ],
                        [
                          0.532,
                          0.8,
                        ],
                        [
                          -0.464,
                          -0.7,
                        ],
                        [
                          -0.531,
                          -0.801,
                        ],
                      ],
                      v: [
                        [
                          -1.345,
                          -0.671,
                        ],
                        [
                          0.049,
                          1.429,
                        ],
                        [
                          1.344,
                          0.672,
                        ],
                        [
                          -0.05,
                          -1.428,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.131,
                      151.657,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0.873,
                          0.414,
                        ],
                        [
                          1.753,
                          1.8,
                        ],
                        [
                          -0.673,
                          -0.692,
                        ],
                        [
                          -2.38,
                          -1.128,
                        ],
                      ],
                      o: [
                        [
                          -2.271,
                          -1.076,
                        ],
                        [
                          -0.675,
                          -0.693,
                        ],
                        [
                          1.838,
                          1.887,
                        ],
                        [
                          0.868,
                          0.412,
                        ],
                      ],
                      v: [
                        [
                          3.45,
                          1.646,
                        ],
                        [
                          -2.588,
                          -2.66,
                        ],
                        [
                          -3.65,
                          -1.6,
                        ],
                        [
                          2.693,
                          2.942,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      69.155,
                      3.604,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 9,
          op: 759,
          st: 9,
          bm: 0,
        },
        {
          ddd: 1,
          ind: 5,
          ty: 4,
          nm: 'Capa 1 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8,
            },
            ry: {
              a: 0,
              k: 0,
              ix: 9,
            },
            rz: {
              a: 0,
              k: 0,
              ix: 10,
            },
            or: {
              a: 0,
              k: [
                0,
                0,
                0,
              ],
              ix: 7,
            },
            p: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 0.768,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  t: 0,
                  s: [
                    78.571,
                    80.759,
                    42,
                  ],
                  to: [
                    0,
                    0,
                    -5.569,
                  ],
                  ti: [
                    0,
                    0,
                    11.003,
                  ],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0.396,
                  },
                  t: 15,
                  s: [
                    78.571,
                    80.759,
                    -8.936,
                  ],
                  to: [
                    0,
                    0,
                    -2.826,
                  ],
                  ti: [
                    0,
                    0,
                    1.431,
                  ],
                },
                {
                  t: 20,
                  s: [
                    78.571,
                    80.759,
                    0,
                  ],
                },
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                72.688,
                71.924,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 0,
                  s: [
                    11,
                    11,
                    11,
                  ],
                },
                {
                  t: 5,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.501,
                          -0.829,
                        ],
                        [
                          -1.184,
                          -0.353,
                        ],
                        [
                          0.925,
                          0.276,
                        ],
                        [
                          0.436,
                          0.723,
                        ],
                      ],
                      o: [
                        [
                          0.64,
                          1.057,
                        ],
                        [
                          0.926,
                          0.276,
                        ],
                        [
                          -0.809,
                          -0.241,
                        ],
                        [
                          -0.499,
                          -0.825,
                        ],
                      ],
                      v: [
                        [
                          -1.813,
                          -0.431,
                        ],
                        [
                          0.991,
                          1.737,
                        ],
                        [
                          1.389,
                          0.29,
                        ],
                        [
                          -0.517,
                          -1.188,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      142.813,
                      54.545,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -1.5,
                        ],
                        [
                          1.501,
                          0,
                        ],
                        [
                          0,
                          1.5,
                        ],
                        [
                          -1.5,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          1.5,
                        ],
                        [
                          -1.5,
                          0,
                        ],
                        [
                          0,
                          -1.5,
                        ],
                        [
                          1.501,
                          0,
                        ],
                      ],
                      v: [
                        [
                          2.717,
                          0,
                        ],
                        [
                          0,
                          2.717,
                        ],
                        [
                          -2.717,
                          0,
                        ],
                        [
                          0,
                          -2.717,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      133.255,
                      44.064,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0.483,
                          0.839,
                        ],
                        [
                          0.048,
                          0.698,
                        ],
                        [
                          -0.067,
                          -0.965,
                        ],
                        [
                          -0.484,
                          -0.84,
                        ],
                      ],
                      o: [
                        [
                          -0.348,
                          -0.604,
                        ],
                        [
                          -0.066,
                          -0.957,
                        ],
                        [
                          0.067,
                          0.966,
                        ],
                        [
                          0.482,
                          0.836,
                        ],
                      ],
                      v: [
                        [
                          0.846,
                          0.66,
                        ],
                        [
                          0.238,
                          -1.288,
                        ],
                        [
                          -1.262,
                          -1.288,
                        ],
                        [
                          -0.449,
                          1.417,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      27.398,
                      9.5,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 3',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.965,
                          -0.027,
                        ],
                        [
                          -1.761,
                          0.755,
                        ],
                        [
                          0.878,
                          -0.377,
                        ],
                        [
                          1.639,
                          0.047,
                        ],
                      ],
                      o: [
                        [
                          1.919,
                          0.056,
                        ],
                        [
                          0.885,
                          -0.379,
                        ],
                        [
                          -1.51,
                          0.647,
                        ],
                        [
                          -0.965,
                          -0.027,
                        ],
                      ],
                      v: [
                        [
                          -2.707,
                          1.346,
                        ],
                        [
                          2.787,
                          0.27,
                        ],
                        [
                          2.03,
                          -1.025,
                        ],
                        [
                          -2.707,
                          -0.154,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      129.262,
                      142.197,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 4',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.965,
                          -0.026,
                        ],
                        [
                          -1.642,
                          1.077,
                        ],
                        [
                          0.811,
                          -0.532,
                        ],
                        [
                          1.723,
                          0.046,
                        ],
                      ],
                      o: [
                        [
                          1.963,
                          0.052,
                        ],
                        [
                          0.804,
                          -0.528,
                        ],
                        [
                          -1.439,
                          0.944,
                        ],
                        [
                          -0.965,
                          -0.026,
                        ],
                      ],
                      v: [
                        [
                          -2.663,
                          1.665,
                        ],
                        [
                          2.824,
                          0.111,
                        ],
                        [
                          2.066,
                          -1.185,
                        ],
                        [
                          -2.663,
                          0.165,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      3.877,
                      49.923,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 5',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.554,
                          0,
                        ],
                        [
                          0,
                          0.554,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.554,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.554,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.003,
                          0.001,
                        ],
                        [
                          0.001,
                          1.004,
                        ],
                        [
                          -1.003,
                          0.001,
                        ],
                        [
                          0.001,
                          -1.004,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.11,
                      13.916,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 6',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 6,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.555,
                          0,
                        ],
                        [
                          0,
                          0.555,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.555,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.555,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.004,
                          0,
                        ],
                        [
                          0,
                          1.004,
                        ],
                        [
                          -1.004,
                          0,
                        ],
                        [
                          0,
                          -1.004,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      100.693,
                      128.689,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 7',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 7,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.916,
                        ],
                        [
                          0.916,
                          0,
                        ],
                        [
                          0,
                          0.915,
                        ],
                        [
                          -0.916,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.915,
                        ],
                        [
                          -0.916,
                          0,
                        ],
                        [
                          0,
                          -0.916,
                        ],
                        [
                          0.916,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.658,
                          0,
                        ],
                        [
                          0,
                          1.658,
                        ],
                        [
                          -1.658,
                          0,
                        ],
                        [
                          0,
                          -1.658,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.11,
                      135.126,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 8',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 8,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -1.243,
                          0.643,
                        ],
                        [
                          0.612,
                          1.25,
                        ],
                        [
                          1.208,
                          -0.633,
                        ],
                        [
                          -0.202,
                          -0.134,
                        ],
                        [
                          0.142,
                          -0.23,
                        ],
                        [
                          0.283,
                          0.149,
                        ],
                        [
                          0.374,
                          0.176,
                        ],
                        [
                          -0.005,
                          0.325,
                        ],
                        [
                          -0.299,
                          0.114,
                        ],
                        [
                          -0.59,
                          1.081,
                        ],
                        [
                          -0.103,
                          0.267,
                        ],
                        [
                          -0.339,
                          0.013,
                        ],
                        [
                          -0.126,
                          -0.355,
                        ],
                        [
                          -1.441,
                          -0.565,
                        ],
                        [
                          -0.002,
                          -0.334,
                        ],
                        [
                          0.308,
                          -0.12,
                        ],
                        [
                          0.521,
                          -1.462,
                        ],
                        [
                          0.326,
                          0.005,
                        ],
                        [
                          0.124,
                          0.307,
                        ],
                        [
                          0.148,
                          0.305,
                        ],
                        [
                          -0.254,
                          0.136,
                        ],
                        [
                          -0.175,
                          -0.296,
                        ],
                        [
                          -0.096,
                          -0.173,
                        ],
                      ],
                      o: [
                        [
                          -1.226,
                          -0.643,
                        ],
                        [
                          -0.61,
                          1.238,
                        ],
                        [
                          0.247,
                          0.151,
                        ],
                        [
                          0.264,
                          0.176,
                        ],
                        [
                          -0.144,
                          0.235,
                        ],
                        [
                          -0.365,
                          -0.194,
                        ],
                        [
                          -0.289,
                          -0.136,
                        ],
                        [
                          0.005,
                          -0.326,
                        ],
                        [
                          1.15,
                          -0.437,
                        ],
                        [
                          0.137,
                          -0.251,
                        ],
                        [
                          0.118,
                          -0.309,
                        ],
                        [
                          0.319,
                          -0.011,
                        ],
                        [
                          0.52,
                          1.462,
                        ],
                        [
                          0.311,
                          0.122,
                        ],
                        [
                          0.002,
                          0.335,
                        ],
                        [
                          -1.448,
                          0.558,
                        ],
                        [
                          -0.128,
                          0.359,
                        ],
                        [
                          -0.343,
                          -0.006,
                        ],
                        [
                          -0.126,
                          -0.315,
                        ],
                        [
                          -0.154,
                          -0.314,
                        ],
                        [
                          0.25,
                          -0.133,
                        ],
                        [
                          0.081,
                          0.136,
                        ],
                        [
                          0.606,
                          -1.222,
                        ],
                      ],
                      v: [
                        [
                          2.73,
                          0.007,
                        ],
                        [
                          0.001,
                          -2.784,
                        ],
                        [
                          -2.713,
                          0.001,
                        ],
                        [
                          -2.053,
                          0.406,
                        ],
                        [
                          -1.855,
                          1.09,
                        ],
                        [
                          -2.553,
                          1.221,
                        ],
                        [
                          -3.66,
                          0.658,
                        ],
                        [
                          -4.116,
                          -0.006,
                        ],
                        [
                          -3.638,
                          -0.653,
                        ],
                        [
                          -1.016,
                          -2.921,
                        ],
                        [
                          -0.671,
                          -3.709,
                        ],
                        [
                          -0.012,
                          -4.221,
                        ],
                        [
                          0.671,
                          -3.701,
                        ],
                        [
                          3.616,
                          -0.663,
                        ],
                        [
                          4.119,
                          0.003,
                        ],
                        [
                          3.622,
                          0.674,
                        ],
                        [
                          0.673,
                          3.706,
                        ],
                        [
                          -0.008,
                          4.227,
                        ],
                        [
                          -0.671,
                          3.723,
                        ],
                        [
                          -1.09,
                          2.795,
                        ],
                        [
                          -0.938,
                          2.073,
                        ],
                        [
                          -0.248,
                          2.334,
                        ],
                        [
                          0.003,
                          2.783,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      136.334,
                      4.482,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 9',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 9,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 750,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Huellas_pedazo contornos',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.919,
                      -29.67,
                    ],
                    [
                      0.919,
                      -29.67,
                    ],
                    [
                      0.919,
                      29.669,
                    ],
                    [
                      -0.919,
                      29.669,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.136999990426,
                  0.136999990426,
                  0.136999990426,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  103.954,
                  76.531,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.819,
                      -29.67,
                    ],
                    [
                      0.819,
                      -29.67,
                    ],
                    [
                      0.819,
                      29.669,
                    ],
                    [
                      -0.819,
                      29.669,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.925,
                  0.458999992819,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  105.691,
                  76.531,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Capa 6 contornos',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 24,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 30,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 79,
              s: [
                100,
              ],
            },
            {
              t: 92,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            86.674,
            66.816,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            14.642,
            19.005,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                  0.667,
                  0.667,
                ],
                y: [
                  1,
                  1,
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                  0.333,
                  0.333,
                ],
                y: [
                  0,
                  0,
                  0,
                ],
              },
              t: 26,
              s: [
                91,
                91,
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                  0.667,
                  0.667,
                ],
                y: [
                  1,
                  1,
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                  0.333,
                  0.333,
                ],
                y: [
                  0,
                  0,
                  0,
                ],
              },
              t: 31,
              s: [
                110.625,
                110.625,
                100,
              ],
            },
            {
              t: 36,
              s: [
                100,
                100,
                100,
              ],
            },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.43,
                    ],
                  ],
                  v: [
                    [
                      4.046,
                      3.652,
                    ],
                    [
                      -4.045,
                      3.652,
                    ],
                    [
                      -4.824,
                      2.874,
                    ],
                    [
                      -4.824,
                      -2.874,
                    ],
                    [
                      -4.045,
                      -3.652,
                    ],
                    [
                      4.046,
                      -3.652,
                    ],
                    [
                      4.824,
                      -2.874,
                    ],
                    [
                      4.824,
                      2.874,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 0.5,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  13.151,
                  25.331,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.431,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.429,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.431,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.429,
                    ],
                  ],
                  v: [
                    [
                      4.045,
                      3.652,
                    ],
                    [
                      -4.046,
                      3.652,
                    ],
                    [
                      -4.824,
                      2.874,
                    ],
                    [
                      -4.824,
                      -2.874,
                    ],
                    [
                      -4.046,
                      -3.652,
                    ],
                    [
                      4.045,
                      -3.652,
                    ],
                    [
                      4.824,
                      -2.874,
                    ],
                    [
                      4.824,
                      2.874,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 0.5,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  23.211,
                  33.109,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.43,
                    ],
                  ],
                  v: [
                    [
                      5.06,
                      4.421,
                    ],
                    [
                      -5.059,
                      4.421,
                    ],
                    [
                      -5.838,
                      3.641,
                    ],
                    [
                      -5.838,
                      -3.643,
                    ],
                    [
                      -5.059,
                      -4.421,
                    ],
                    [
                      5.06,
                      -4.421,
                    ],
                    [
                      5.838,
                      -3.643,
                    ],
                    [
                      5.838,
                      3.641,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 0.5,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  7.088,
                  17.349,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.43,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.43,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.43,
                    ],
                  ],
                  v: [
                    [
                      5.415,
                      4.335,
                    ],
                    [
                      -5.414,
                      4.335,
                    ],
                    [
                      -6.193,
                      3.555,
                    ],
                    [
                      -6.193,
                      -3.555,
                    ],
                    [
                      -5.414,
                      -4.335,
                    ],
                    [
                      5.415,
                      -4.335,
                    ],
                    [
                      6.193,
                      -3.555,
                    ],
                    [
                      6.193,
                      3.555,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  0.596000043084,
                  0.804000016755,
                  0.289999988032,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 0.5,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  10.639,
                  5.584,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'Capa 5 contornos',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0,
                ],
              },
              t: 18,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0,
                ],
              },
              t: 22,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 79,
              s: [
                100,
              ],
            },
            {
              t: 92,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 14,
              s: [
                117.864,
                66.541,
                0,
              ],
              to: [
                -4.744,
                0,
                0,
              ],
              ti: [
                4.744,
                0,
                0,
              ],
            },
            {
              t: 22,
              s: [
                89.4,
                66.541,
                0,
              ],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            14.451,
            17.73,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.149,
                      2.326,
                    ],
                    [
                      -0.646,
                      -0.904,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0,
                      -2.552,
                    ],
                    [
                      0.323,
                      2.552,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  25.584,
                  32.109,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.717,
                      2.94,
                    ],
                    [
                      0.217,
                      -0.892,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.359,
                      -1.952,
                    ],
                    [
                      -0.21,
                      1.952,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  25.149,
                  23.551,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.022,
                      2.345,
                    ],
                    [
                      -0.689,
                      -1.859,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.104,
                      -2.445,
                    ],
                    [
                      0.344,
                      2.445,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.446,
                  23.603,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.343,
                      2.304,
                    ],
                    [
                      0.786,
                      -2.167,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.393,
                      -2.438,
                    ],
                    [
                      -0.393,
                      2.438,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  15.18,
                  24.331,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.042,
                      1.336,
                    ],
                    [
                      0.275,
                      -1.781,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.159,
                      -2.344,
                    ],
                    [
                      -0.074,
                      2.344,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  21.914,
                  15.246,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.531,
                      3.064,
                    ],
                    [
                      -0.249,
                      -1.564,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.266,
                      -3.269,
                    ],
                    [
                      0.02,
                      3.269,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.519,
                  15.034,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.709,
                      2.572,
                    ],
                    [
                      0,
                      -0.555,
                    ],
                    [
                      0.059,
                      -0.118,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.556,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.355,
                      -3.064,
                    ],
                    [
                      -0.277,
                      -0.289,
                    ],
                    [
                      -0.355,
                      3.064,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  11.486,
                  16.485,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.646,
                      2.427,
                    ],
                    [
                      0,
                      -0.534,
                    ],
                    [
                      0.045,
                      -0.115,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.534,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.323,
                      -2.946,
                    ],
                    [
                      -0.263,
                      -0.278,
                    ],
                    [
                      -0.323,
                      2.946,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.173,
                  4.595,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.685,
                      1.703,
                    ],
                    [
                      -1.229,
                      -2.79,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.615,
                      -2.577,
                    ],
                    [
                      0.615,
                      2.577,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.919,
                  4.453,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.533,
                      1.998,
                    ],
                    [
                      -0.957,
                      -2.747,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.479,
                      -2.654,
                    ],
                    [
                      0.479,
                      2.654,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  10.292,
                  16.348,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.706,
                      2.175,
                    ],
                    [
                      -1.396,
                      -2.916,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.698,
                      -3.116,
                    ],
                    [
                      0.698,
                      3.116,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  12.319,
                  4.764,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.38,
                      -0.046,
                    ],
                    [
                      -0.201,
                      -4.079,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.637,
                      0.019,
                    ],
                    [
                      -1.998,
                      -0.11,
                    ],
                  ],
                  o: [
                    [
                      -6.494,
                      0.35,
                    ],
                    [
                      -2.006,
                      0.067,
                    ],
                    [
                      0.201,
                      4.079,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.617,
                      -0.007,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      12.715,
                      -4.642,
                    ],
                    [
                      -3.821,
                      -3.785,
                    ],
                    [
                      -12.514,
                      0.562,
                    ],
                    [
                      -3.534,
                      3.86,
                    ],
                    [
                      8.149,
                      3.271,
                    ],
                    [
                      12.715,
                      3.469,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  15.907,
                  4.892,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.905,
                      -0.227,
                    ],
                    [
                      2.006,
                      -0.535,
                    ],
                    [
                      0,
                      -1.07,
                    ],
                    [
                      -6.018,
                      0.669,
                    ],
                    [
                      -2.206,
                      0.201,
                    ],
                    [
                      -0.658,
                      0.081,
                    ],
                  ],
                  o: [
                    [
                      -2.808,
                      0.231,
                    ],
                    [
                      -3.811,
                      0.455,
                    ],
                    [
                      -2.006,
                      0.535,
                    ],
                    [
                      0,
                      1.069,
                    ],
                    [
                      6.018,
                      -0.668,
                    ],
                    [
                      0.444,
                      -0.04,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      14.201,
                      -4.963,
                    ],
                    [
                      6.194,
                      -4.251,
                    ],
                    [
                      -11.593,
                      -2.259,
                    ],
                    [
                      -14.201,
                      1.286,
                    ],
                    [
                      -6.912,
                      4.294,
                    ],
                    [
                      12.479,
                      3.425,
                    ],
                    [
                      14.171,
                      3.236,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  14.451,
                  15.87,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.674,
                      -0.112,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.009,
                      -2.892,
                    ],
                    [
                      -3.945,
                      0,
                    ],
                    [
                      -2.511,
                      0.186,
                    ],
                  ],
                  o: [
                    [
                      -2.373,
                      0.363,
                    ],
                    [
                      -4.013,
                      0.267,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.011,
                      3.277,
                    ],
                    [
                      3.408,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      10.781,
                      -3.754,
                    ],
                    [
                      4.209,
                      -2.934,
                    ],
                    [
                      -7.226,
                      -2.333,
                    ],
                    [
                      -10.77,
                      0.477,
                    ],
                    [
                      -2.211,
                      3.62,
                    ],
                    [
                      10.781,
                      2.751,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  17.841,
                  23.7,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      2.316,
                      -0.066,
                    ],
                    [
                      -0.036,
                      -2.882,
                    ],
                    [
                      -3.143,
                      0.067,
                    ],
                    [
                      -1.206,
                      0.091,
                    ],
                  ],
                  o: [
                    [
                      -1.762,
                      0.283,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.041,
                      3.21,
                    ],
                    [
                      0.759,
                      -0.016,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      5.511,
                      -3.327,
                    ],
                    [
                      -0.593,
                      -2.757,
                    ],
                    [
                      -5.475,
                      -0.016,
                    ],
                    [
                      2.483,
                      3.26,
                    ],
                    [
                      5.511,
                      3.089,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  23.111,
                  31.883,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 15',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 17,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: 'Capa 2 contornos',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            74.337,
            91.396,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            33.033,
            61.114,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.697,
                      -0.17,
                    ],
                    [
                      0.978,
                      0.288,
                    ],
                    [
                      -1.617,
                      0.42,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.618,
                      -0.42,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.905,
                      -0.093,
                    ],
                    [
                      -2.361,
                      0.142,
                    ],
                    [
                      0.708,
                      0.335,
                    ],
                    [
                      2.361,
                      -0.755,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  14.121,
                  68.913,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.674,
                      0.814,
                    ],
                    [
                      -1.784,
                      -0.945,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.302,
                      -1.312,
                    ],
                    [
                      1.302,
                      1.312,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  28.85,
                  56.754,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.924,
                      1.116,
                    ],
                    [
                      -2.446,
                      -1.295,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.785,
                      -1.799,
                    ],
                    [
                      1.785,
                      1.799,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  29.647,
                  56.039,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.262,
                      1.038,
                    ],
                    [
                      -0.432,
                      0.592,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -3.095,
                      0.889,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.615,
                      -2.136,
                    ],
                    [
                      0.762,
                      -0.797,
                    ],
                    [
                      1.009,
                      -0.615,
                    ],
                    [
                      0.536,
                      -1.46,
                    ],
                    [
                      0.146,
                      -0.698,
                    ],
                    [
                      -0.122,
                      -1.806,
                    ],
                    [
                      2.637,
                      -6.854,
                    ],
                    [
                      3.772,
                      6.584,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.262,
                      -1.039,
                    ],
                    [
                      0.433,
                      -0.592,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      3.096,
                      -0.889,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.615,
                      2.136,
                    ],
                    [
                      -0.761,
                      0.798,
                    ],
                    [
                      -1.01,
                      0.615,
                    ],
                    [
                      -0.537,
                      1.458,
                    ],
                    [
                      -0.147,
                      0.696,
                    ],
                    [
                      0.122,
                      1.804,
                    ],
                    [
                      -1.476,
                      3.836,
                    ],
                    [
                      -2.969,
                      -5.181,
                    ],
                  ],
                  v: [
                    [
                      -13.984,
                      -2.774,
                    ],
                    [
                      -10.581,
                      -3.553,
                    ],
                    [
                      -4.415,
                      -11.432,
                    ],
                    [
                      -1.542,
                      -16.462,
                    ],
                    [
                      2.329,
                      -19.968,
                    ],
                    [
                      10.141,
                      -22.936,
                    ],
                    [
                      15.338,
                      -21.8,
                    ],
                    [
                      12.688,
                      -15.166,
                    ],
                    [
                      7.45,
                      -11.474,
                    ],
                    [
                      5.428,
                      -8.586,
                    ],
                    [
                      2.764,
                      -0.678,
                    ],
                    [
                      3.377,
                      5.241,
                    ],
                    [
                      0.799,
                      20.1,
                    ],
                    [
                      -13.984,
                      16.867,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  27.063,
                  71.711,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.016,
                      0.041,
                    ],
                    [
                      -0.151,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.068,
                      -0.068,
                    ],
                    [
                      0,
                      -0.096,
                    ],
                    [
                      0.196,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.068,
                      0.068,
                    ],
                    [
                      0,
                      0.096,
                    ],
                  ],
                  o: [
                    [
                      0.052,
                      -0.133,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.095,
                      0,
                    ],
                    [
                      0.068,
                      0.067,
                    ],
                    [
                      0.001,
                      0.196,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.095,
                      0,
                    ],
                    [
                      -0.067,
                      -0.067,
                    ],
                    [
                      0,
                      -0.046,
                    ],
                  ],
                  v: [
                    [
                      -2.947,
                      -0.124,
                    ],
                    [
                      -2.615,
                      -0.352,
                    ],
                    [
                      2.611,
                      -0.363,
                    ],
                    [
                      2.865,
                      -0.258,
                    ],
                    [
                      2.969,
                      -0.007,
                    ],
                    [
                      2.615,
                      0.352,
                    ],
                    [
                      -2.613,
                      0.363,
                    ],
                    [
                      -2.866,
                      0.258,
                    ],
                    [
                      -2.971,
                      0.007,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.552999997606,
                  0.552999997606,
                  0.552999997606,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  40.117,
                  5.36,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.929,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.93,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.929,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.091,
                      0.944,
                    ],
                    [
                      -2.515,
                      -0.243,
                    ],
                    [
                      0.243,
                      -2.516,
                    ],
                    [
                      0.285,
                      -0.523,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.929,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.929,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.929,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.422,
                      -0.775,
                    ],
                    [
                      0.243,
                      -2.515,
                    ],
                    [
                      2.516,
                      0.242,
                    ],
                    [
                      -0.061,
                      0.63,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.929,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.93,
                    ],
                  ],
                  v: [
                    [
                      19.934,
                      -40.934,
                    ],
                    [
                      -19.933,
                      -40.934,
                    ],
                    [
                      -21.616,
                      -39.25,
                    ],
                    [
                      -21.616,
                      39.251,
                    ],
                    [
                      -19.933,
                      40.934,
                    ],
                    [
                      -3.041,
                      40.934,
                    ],
                    [
                      -3.575,
                      38.309,
                    ],
                    [
                      1.428,
                      34.189,
                    ],
                    [
                      5.55,
                      39.191,
                    ],
                    [
                      5.017,
                      40.934,
                    ],
                    [
                      19.934,
                      40.934,
                    ],
                    [
                      21.616,
                      39.251,
                    ],
                    [
                      21.616,
                      -39.25,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  40.116,
                  44.451,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.737,
                      0.168,
                    ],
                    [
                      0.168,
                      -1.738,
                    ],
                    [
                      -1.738,
                      -0.167,
                    ],
                    [
                      -0.167,
                      1.737,
                    ],
                  ],
                  o: [
                    [
                      -1.737,
                      -0.168,
                    ],
                    [
                      -0.168,
                      1.737,
                    ],
                    [
                      1.737,
                      0.168,
                    ],
                    [
                      0.168,
                      -1.737,
                    ],
                  ],
                  v: [
                    [
                      0.304,
                      -3.151,
                    ],
                    [
                      -3.151,
                      -0.304,
                    ],
                    [
                      -0.304,
                      3.15,
                    ],
                    [
                      3.15,
                      0.304,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.82,
                      0.176,
                    ],
                    [
                      -0.176,
                      1.82,
                    ],
                    [
                      -1.821,
                      -0.176,
                    ],
                    [
                      0.177,
                      -1.821,
                    ],
                  ],
                  o: [
                    [
                      -1.821,
                      -0.177,
                    ],
                    [
                      0.175,
                      -1.821,
                    ],
                    [
                      1.82,
                      0.175,
                    ],
                    [
                      -0.176,
                      1.82,
                    ],
                  ],
                  v: [
                    [
                      -0.319,
                      3.302,
                    ],
                    [
                      -3.302,
                      -0.319,
                    ],
                    [
                      0.319,
                      -3.302,
                    ],
                    [
                      3.301,
                      0.319,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Combinar trazados 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.552999997606,
                  0.552999997606,
                  0.552999997606,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  40.982,
                  83.202,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.146,
                      0.057,
                    ],
                    [
                      0.057,
                      -0.146,
                    ],
                    [
                      -0.146,
                      -0.057,
                    ],
                    [
                      -0.057,
                      0.146,
                    ],
                  ],
                  o: [
                    [
                      -0.146,
                      -0.057,
                    ],
                    [
                      -0.056,
                      0.146,
                    ],
                    [
                      0.146,
                      0.056,
                    ],
                    [
                      0.057,
                      -0.146,
                    ],
                  ],
                  v: [
                    [
                      0.103,
                      -0.265,
                    ],
                    [
                      -0.266,
                      -0.103,
                    ],
                    [
                      -0.104,
                      0.266,
                    ],
                    [
                      0.264,
                      0.104,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.183,
                      0.071,
                    ],
                    [
                      -0.071,
                      0.183,
                    ],
                    [
                      -0.183,
                      -0.072,
                    ],
                    [
                      0.071,
                      -0.183,
                    ],
                  ],
                  o: [
                    [
                      -0.183,
                      -0.071,
                    ],
                    [
                      0.071,
                      -0.183,
                    ],
                    [
                      0.183,
                      0.07,
                    ],
                    [
                      -0.071,
                      0.183,
                    ],
                  ],
                  v: [
                    [
                      -0.13,
                      0.331,
                    ],
                    [
                      -0.331,
                      -0.129,
                    ],
                    [
                      0.128,
                      -0.331,
                    ],
                    [
                      0.331,
                      0.13,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Combinar trazados 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  15.83,
                  16.934,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.106,
                      0.042,
                    ],
                    [
                      0.037,
                      0,
                    ],
                    [
                      0.054,
                      -0.054,
                    ],
                    [
                      0,
                      -0.077,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.055,
                      -0.054,
                    ],
                    [
                      -0.076,
                      0,
                    ],
                    [
                      -0.054,
                      0.054,
                    ],
                    [
                      0,
                      0.077,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -0.032,
                      -0.013,
                    ],
                    [
                      -0.076,
                      0,
                    ],
                    [
                      -0.053,
                      0.054,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.076,
                    ],
                    [
                      0.054,
                      0.053,
                    ],
                    [
                      0.076,
                      0,
                    ],
                    [
                      0.054,
                      -0.055,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.001,
                      -0.121,
                    ],
                  ],
                  v: [
                    [
                      0.098,
                      -2.051,
                    ],
                    [
                      -0.007,
                      -2.07,
                    ],
                    [
                      -0.208,
                      -1.986,
                    ],
                    [
                      -0.292,
                      -1.783,
                    ],
                    [
                      -0.279,
                      1.786,
                    ],
                    [
                      -0.195,
                      1.988,
                    ],
                    [
                      0.007,
                      2.072,
                    ],
                    [
                      0.208,
                      1.988,
                    ],
                    [
                      0.292,
                      1.785,
                    ],
                    [
                      0.281,
                      -1.785,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.04,
                      0.016,
                    ],
                    [
                      0,
                      0.151,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.067,
                      0.068,
                    ],
                    [
                      -0.096,
                      0,
                    ],
                    [
                      -0.001,
                      -0.198,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.068,
                      -0.068,
                    ],
                    [
                      0.095,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -0.133,
                      -0.052,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -0.096,
                    ],
                    [
                      0.067,
                      -0.068,
                    ],
                    [
                      0.197,
                      -0.001,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.095,
                    ],
                    [
                      -0.067,
                      0.067,
                    ],
                    [
                      -0.046,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.124,
                      2.118,
                    ],
                    [
                      -0.352,
                      1.786,
                    ],
                    [
                      -0.363,
                      -1.783,
                    ],
                    [
                      -0.258,
                      -2.036,
                    ],
                    [
                      -0.007,
                      -2.141,
                    ],
                    [
                      0.352,
                      -1.785,
                    ],
                    [
                      0.363,
                      1.785,
                    ],
                    [
                      0.258,
                      2.038,
                    ],
                    [
                      0.007,
                      2.143,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Combinar trazados 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  15.838,
                  20.113,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.409,
                      -0.261,
                    ],
                    [
                      0.551,
                      -0.351,
                    ],
                    [
                      -0.409,
                      0.26,
                    ],
                    [
                      -0.552,
                      0.352,
                    ],
                  ],
                  o: [
                    [
                      -0.551,
                      0.351,
                    ],
                    [
                      -0.406,
                      0.259,
                    ],
                    [
                      0.55,
                      -0.351,
                    ],
                    [
                      0.405,
                      -0.258,
                    ],
                  ],
                  v: [
                    [
                      0.638,
                      -0.85,
                    ],
                    [
                      -1.016,
                      0.203,
                    ],
                    [
                      -0.637,
                      0.851,
                    ],
                    [
                      1.017,
                      -0.203,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  64.395,
                  13.711,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.409,
                      -0.26,
                    ],
                    [
                      0.551,
                      -0.352,
                    ],
                    [
                      -0.409,
                      0.26,
                    ],
                    [
                      -0.552,
                      0.352,
                    ],
                  ],
                  o: [
                    [
                      -0.551,
                      0.351,
                    ],
                    [
                      -0.406,
                      0.258,
                    ],
                    [
                      0.55,
                      -0.351,
                    ],
                    [
                      0.405,
                      -0.258,
                    ],
                  ],
                  v: [
                    [
                      0.638,
                      -0.851,
                    ],
                    [
                      -1.016,
                      0.203,
                    ],
                    [
                      -0.637,
                      0.85,
                    ],
                    [
                      1.017,
                      -0.204,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  64.395,
                  11.72,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.407,
                      -0.259,
                    ],
                    [
                      -0.551,
                      -0.351,
                    ],
                    [
                      0.407,
                      0.259,
                    ],
                    [
                      0.551,
                      0.351,
                    ],
                  ],
                  o: [
                    [
                      0.551,
                      0.351,
                    ],
                    [
                      0.408,
                      0.26,
                    ],
                    [
                      -0.551,
                      -0.351,
                    ],
                    [
                      -0.408,
                      -0.261,
                    ],
                  ],
                  v: [
                    [
                      -1.016,
                      -0.202,
                    ],
                    [
                      0.637,
                      0.85,
                    ],
                    [
                      1.016,
                      0.204,
                    ],
                    [
                      -0.637,
                      -0.85,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  15.837,
                  13.711,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.407,
                      -0.259,
                    ],
                    [
                      -0.551,
                      -0.351,
                    ],
                    [
                      0.407,
                      0.259,
                    ],
                    [
                      0.551,
                      0.351,
                    ],
                  ],
                  o: [
                    [
                      0.551,
                      0.352,
                    ],
                    [
                      0.408,
                      0.26,
                    ],
                    [
                      -0.551,
                      -0.351,
                    ],
                    [
                      -0.408,
                      -0.261,
                    ],
                  ],
                  v: [
                    [
                      -1.016,
                      -0.203,
                    ],
                    [
                      0.637,
                      0.851,
                    ],
                    [
                      1.016,
                      0.203,
                    ],
                    [
                      -0.637,
                      -0.85,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  15.837,
                  11.72,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.743,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      1.742,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.743,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -1.743,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.743,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -1.743,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.743,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      1.742,
                    ],
                  ],
                  v: [
                    [
                      20.298,
                      43.657,
                    ],
                    [
                      -20.297,
                      43.657,
                    ],
                    [
                      -23.452,
                      40.502,
                    ],
                    [
                      -23.452,
                      -40.502,
                    ],
                    [
                      -20.297,
                      -43.657,
                    ],
                    [
                      20.298,
                      -43.657,
                    ],
                    [
                      23.452,
                      -40.502,
                    ],
                    [
                      23.452,
                      40.502,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.136999990426,
                  0.136999990426,
                  0.136999990426,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  40.116,
                  45.279,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      2.617,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      2.616,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.617,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -2.616,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -2.617,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      -2.616,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      2.617,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      2.616,
                    ],
                  ],
                  v: [
                    [
                      20.352,
                      45.166,
                    ],
                    [
                      -20.352,
                      45.166,
                    ],
                    [
                      -25.09,
                      40.429,
                    ],
                    [
                      -25.09,
                      -40.429,
                    ],
                    [
                      -20.352,
                      -45.166,
                    ],
                    [
                      20.352,
                      -45.166,
                    ],
                    [
                      25.09,
                      -40.429,
                    ],
                    [
                      25.09,
                      40.429,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.925,
                  0.458999992819,
                  0,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  40.116,
                  45.416,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 15',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.339,
                      -4.248,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.296,
                      -2.416,
                    ],
                    [
                      -0.382,
                      -4.283,
                    ],
                    [
                      1.025,
                      -3.748,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -12.531,
                      2.142,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.431,
                      9.833,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.339,
                      4.248,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.298,
                      2.417,
                    ],
                    [
                      0.382,
                      4.281,
                    ],
                    [
                      -1.026,
                      3.748,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.431,
                      -9.831,
                    ],
                  ],
                  v: [
                    [
                      -0.347,
                      -36.161,
                    ],
                    [
                      -5.841,
                      -32.846,
                    ],
                    [
                      -13.468,
                      -13.6,
                    ],
                    [
                      -15.2,
                      -6.661,
                    ],
                    [
                      -14.133,
                      5.646,
                    ],
                    [
                      -13.983,
                      15.079,
                    ],
                    [
                      -17.594,
                      27.73,
                    ],
                    [
                      1.932,
                      34.952,
                    ],
                    [
                      6.896,
                      15.902,
                    ],
                    [
                      16.163,
                      -0.807,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  17.844,
                  84.884,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 16',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 16,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 1,
      ind: 9,
      ty: 4,
      nm: 'Capa 8 contornos',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 79,
              s: [
                100,
              ],
            },
            {
              t: 92,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        rx: {
          a: 0,
          k: 0,
          ix: 8,
        },
        ry: {
          a: 0,
          k: 0,
          ix: 9,
        },
        rz: {
          a: 0,
          k: 0,
          ix: 10,
        },
        or: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 7,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 0,
              s: [
                197.338,
                63.762,
                13.5,
              ],
              to: [
                -14.417,
                0,
                0,
              ],
              ti: [
                14.417,
                0,
                0,
              ],
            },
            {
              t: 22,
              s: [
                110.838,
                63.762,
                13.5,
              ],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            47.978,
            31.569,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.836,
                      6.49,
                    ],
                    [
                      1.312,
                      -3.752,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.918,
                      -5.326,
                    ],
                    [
                      -0.918,
                      5.326,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  75.993,
                  38.281,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      8.819,
                      13.803,
                    ],
                    [
                      -14.295,
                      3.09,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -10.279,
                      -6.902,
                    ],
                    [
                      10.279,
                      3.271,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  53.553,
                  40.559,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      6.569,
                      -4.41,
                    ],
                    [
                      -5.158,
                      -0.751,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -5.849,
                      1.597,
                    ],
                    [
                      5.849,
                      -1.373,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  57.441,
                  22.056,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      2.749,
                      -0.062,
                    ],
                    [
                      -2.78,
                      2.471,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -2.409,
                      1.39,
                    ],
                    [
                      2.409,
                      -1.39,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  46.715,
                  10.193,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.544,
                      -0.741,
                    ],
                    [
                      -1.451,
                      0.278,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.853,
                      1.066,
                    ],
                    [
                      1.853,
                      -1.066,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  46.416,
                  10.193,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.234,
                      2.373,
                    ],
                    [
                      1.729,
                      -1.069,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.415,
                      1.521,
                    ],
                    [
                      1.415,
                      -1.521,
                    ],
                    [
                      -0.964,
                      1.276,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  49.534,
                  24.154,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.065,
                      0.765,
                    ],
                    [
                      -0.525,
                      -1.028,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.044,
                      -2.098,
                    ],
                    [
                      0.262,
                      2.098,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  32.986,
                  59.401,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      2.12,
                    ],
                    [
                      0.394,
                      -1.836,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.317,
                      -2.622,
                    ],
                    [
                      -0.077,
                      2.622,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  33.827,
                  59.467,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.149,
                      2.326,
                    ],
                    [
                      -0.646,
                      -0.904,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0,
                      -2.552,
                    ],
                    [
                      0.323,
                      2.552,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  25.583,
                  60.469,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.718,
                      2.94,
                    ],
                    [
                      0.217,
                      -0.891,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.359,
                      -1.952,
                    ],
                    [
                      -0.209,
                      1.952,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  25.149,
                  51.911,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.022,
                      2.345,
                    ],
                    [
                      -0.689,
                      -1.859,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.104,
                      -2.445,
                    ],
                    [
                      0.344,
                      2.445,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.446,
                  51.963,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.343,
                      2.304,
                    ],
                    [
                      0.787,
                      -2.167,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.393,
                      -2.438,
                    ],
                    [
                      -0.393,
                      2.438,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  15.18,
                  52.691,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.042,
                      1.336,
                    ],
                    [
                      0.276,
                      -1.782,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.159,
                      -2.344,
                    ],
                    [
                      -0.075,
                      2.344,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  21.914,
                  43.607,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.531,
                      3.064,
                    ],
                    [
                      -0.248,
                      -1.563,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.266,
                      -3.268,
                    ],
                    [
                      0.02,
                      3.268,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.519,
                  43.394,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.339,
                      16.709,
                    ],
                    [
                      -10.502,
                      -4.667,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -4.42,
                      -10.535,
                    ],
                    [
                      5.251,
                      10.535,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  47.71,
                  41.264,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 15',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      2.273,
                      1.877,
                    ],
                    [
                      -2.087,
                      -3.366,
                    ],
                    [
                      0.071,
                      -4.338,
                    ],
                    [
                      0.195,
                      -0.589,
                    ],
                    [
                      2.437,
                      7.474,
                    ],
                    [
                      0.381,
                      0.97,
                    ],
                    [
                      0.226,
                      3.131,
                    ],
                    [
                      -0.408,
                      -1.463,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      2.088,
                      3.366,
                    ],
                    [
                      -0.075,
                      4.577,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.508,
                      -1.557,
                    ],
                    [
                      -0.538,
                      -1.365,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -4.702,
                      -12.196,
                    ],
                    [
                      0.036,
                      -6.35,
                    ],
                    [
                      2.755,
                      3.643,
                    ],
                    [
                      1.141,
                      12.196,
                    ],
                    [
                      2.264,
                      -2.767,
                    ],
                    [
                      0.773,
                      -5.93,
                    ],
                    [
                      -0.243,
                      -12.139,
                    ],
                    [
                      0.242,
                      -6.637,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  41.075,
                  44.907,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 16',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 16,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.709,
                      2.572,
                    ],
                    [
                      0,
                      -0.556,
                    ],
                    [
                      0.058,
                      -0.119,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.555,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.355,
                      -3.064,
                    ],
                    [
                      -0.277,
                      -0.288,
                    ],
                    [
                      -0.355,
                      3.064,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  11.486,
                  44.846,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 17',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 17,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.646,
                      2.427,
                    ],
                    [
                      0,
                      -0.533,
                    ],
                    [
                      0.044,
                      -0.114,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0.535,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.323,
                      -2.946,
                    ],
                    [
                      -0.263,
                      -0.278,
                    ],
                    [
                      -0.323,
                      2.946,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.174,
                  32.955,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 18',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 18,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.685,
                      1.702,
                    ],
                    [
                      -1.229,
                      -2.79,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.615,
                      -2.577,
                    ],
                    [
                      0.615,
                      2.577,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.92,
                  32.814,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 19',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 19,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.534,
                      1.998,
                    ],
                    [
                      -0.957,
                      -2.746,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.479,
                      -2.654,
                    ],
                    [
                      0.479,
                      2.654,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  10.291,
                  44.709,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 20',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 20,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.706,
                      2.175,
                    ],
                    [
                      -1.396,
                      -2.916,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.698,
                      -3.116,
                    ],
                    [
                      0.698,
                      3.116,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  12.318,
                  33.125,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 21',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 21,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.105,
                      2.209,
                    ],
                    [
                      3.074,
                      3.986,
                    ],
                    [
                      0.144,
                      5.043,
                    ],
                    [
                      -1.009,
                      -0.336,
                    ],
                    [
                      -1.682,
                      -1.778,
                    ],
                    [
                      -2.113,
                      -1.057,
                    ],
                    [
                      -3.17,
                      -3.218,
                    ],
                    [
                      -1.105,
                      -1.489,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.104,
                      -2.209,
                    ],
                    [
                      -3.073,
                      -3.986,
                    ],
                    [
                      -0.144,
                      -5.043,
                    ],
                    [
                      1.008,
                      0.336,
                    ],
                    [
                      1.681,
                      1.776,
                    ],
                    [
                      2.114,
                      1.056,
                    ],
                    [
                      3.17,
                      3.218,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -9.317,
                      12.367,
                    ],
                    [
                      -6.58,
                      8.044,
                    ],
                    [
                      -10.806,
                      1.512,
                    ],
                    [
                      -14.504,
                      -7.612,
                    ],
                    [
                      -10.662,
                      -12.799,
                    ],
                    [
                      -7.732,
                      -6.555,
                    ],
                    [
                      0.048,
                      0.697,
                    ],
                    [
                      6.196,
                      5.402,
                    ],
                    [
                      14.648,
                      13.135,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  57.368,
                  13.386,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 22',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 22,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.278,
                      0.014,
                    ],
                    [
                      3.745,
                      -0.201,
                    ],
                    [
                      2.007,
                      -0.067,
                    ],
                    [
                      -0.2,
                      -4.078,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.636,
                      0.019,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.067,
                      -0.268,
                    ],
                    [
                      3.811,
                      -0.454,
                    ],
                    [
                      2.006,
                      -0.535,
                    ],
                    [
                      0,
                      -1.07,
                    ],
                    [
                      -6.018,
                      0.668,
                    ],
                    [
                      -2.207,
                      0.201,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      4.012,
                      -0.267,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.009,
                      -2.891,
                    ],
                    [
                      -3.946,
                      0,
                    ],
                    [
                      -1.004,
                      0,
                    ],
                    [
                      -0.031,
                      -0.098,
                    ],
                    [
                      0.066,
                      -0.669,
                    ],
                    [
                      1.113,
                      -0.209,
                    ],
                    [
                      7.021,
                      -0.201,
                    ],
                    [
                      -0.036,
                      -2.883,
                    ],
                    [
                      -3.143,
                      0.067,
                    ],
                    [
                      -2.407,
                      0.334,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.541,
                      0.869,
                    ],
                    [
                      -1.271,
                      0.736,
                    ],
                    [
                      -0.869,
                      -0.335,
                    ],
                    [
                      2.147,
                      15.888,
                    ],
                    [
                      2.073,
                      0.736,
                    ],
                    [
                      1.872,
                      1.404,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.278,
                      -0.012,
                    ],
                    [
                      -3.745,
                      0.2,
                    ],
                    [
                      -2.006,
                      0.067,
                    ],
                    [
                      0.201,
                      4.079,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.408,
                      -0.016,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.067,
                      0.267,
                    ],
                    [
                      -3.812,
                      0.454,
                    ],
                    [
                      -2.007,
                      0.535,
                    ],
                    [
                      0,
                      1.07,
                    ],
                    [
                      6.019,
                      -0.669,
                    ],
                    [
                      2.206,
                      -0.2,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -4.012,
                      0.268,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.011,
                      3.278,
                    ],
                    [
                      3.945,
                      0,
                    ],
                    [
                      1.003,
                      0,
                    ],
                    [
                      0.032,
                      0.097,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.398,
                      0.451,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.04,
                      3.21,
                    ],
                    [
                      3.143,
                      -0.067,
                    ],
                    [
                      2.407,
                      -0.335,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      2.541,
                      -0.87,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.072,
                      -0.735,
                    ],
                    [
                      -1.872,
                      -1.404,
                    ],
                  ],
                  v: [
                    [
                      2.362,
                      -14.911,
                    ],
                    [
                      -4.924,
                      -12.928,
                    ],
                    [
                      -21.242,
                      -11.167,
                    ],
                    [
                      -35.82,
                      -10.432,
                    ],
                    [
                      -44.513,
                      -6.085,
                    ],
                    [
                      -35.532,
                      -2.786,
                    ],
                    [
                      -23.85,
                      -3.376,
                    ],
                    [
                      -14.087,
                      -2.876,
                    ],
                    [
                      -14.154,
                      -1.204,
                    ],
                    [
                      -27.26,
                      0.081,
                    ],
                    [
                      -45.047,
                      2.072,
                    ],
                    [
                      -47.655,
                      5.617,
                    ],
                    [
                      -40.367,
                      8.626,
                    ],
                    [
                      -20.974,
                      7.757,
                    ],
                    [
                      -12.951,
                      6.686,
                    ],
                    [
                      -12.951,
                      7.355,
                    ],
                    [
                      -25.856,
                      9.227,
                    ],
                    [
                      -37.29,
                      9.829,
                    ],
                    [
                      -40.834,
                      12.637,
                    ],
                    [
                      -32.275,
                      15.781,
                    ],
                    [
                      -18.467,
                      14.865,
                    ],
                    [
                      -10.32,
                      13.57,
                    ],
                    [
                      -9.892,
                      14.805,
                    ],
                    [
                      -11.613,
                      15.312,
                    ],
                    [
                      -25.388,
                      17.587,
                    ],
                    [
                      -30.269,
                      20.329,
                    ],
                    [
                      -22.312,
                      23.604,
                    ],
                    [
                      -8.47,
                      22.335,
                    ],
                    [
                      -2.452,
                      20.796,
                    ],
                    [
                      11.119,
                      18.359,
                    ],
                    [
                      24.296,
                      12.637,
                    ],
                    [
                      40.956,
                      15.23,
                    ],
                    [
                      45.508,
                      -9.661,
                    ],
                    [
                      29.31,
                      -13.107,
                    ],
                    [
                      13.864,
                      -22.268,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.769000004787,
                  0.694000004787,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  47.905,
                  39.899,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 23',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 23,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 0,
      nm: 'Colores 2',
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 79,
              s: [
                100,
              ],
            },
            {
              t: 92,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      w: 160,
      h: 165,
      ip: 41,
      op: 791,
      st: 41,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: 'Capa de formas 1',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: {
                a: 0,
                k: [
                  168.436,
                  175.715,
                ],
                ix: 2,
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 4,
              },
              nm: 'Trazado de rectángulo 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 0,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  0.718,
                  -2.143,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Rectángulo 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
